function MapContact() {
    return (
        <div className="map-contact">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12 map-container">
                        <div>
                            <iframe title="Mansoura Map" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d54695.26601853109!2d31.347820079957792!3d31.04145496229742!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14f79db7a9053547%3A0xf8dab3bbed766c97!2sMansoura%2C%20Mansoura%20Qism%202%2C%20Mansoura%2C%20Dakahlia%20Governorate!5e0!3m2!1sen!2seg!4v1614943633288!5m2!1sen!2seg" loading="lazy"></iframe>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MapContact;